import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  theme:string="";
  inter:any;
  @Input() timer:number;
  @Input() titulo:string;
  @Input() texto1:string;
  @Input() texto2:string;
  @Input() texto3:string;

  constructor( public dialogRef: MatDialogRef<PopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    setTimeout(() => {
      this.fnCargaPopUp();
    }, 57);
    if(this.data){
        this.timer = this.data.timer;
        this.titulo = this.data.titulo;
        this.texto1 = this.data.texto1;
        this.texto2 = this.data.texto2;
        this.texto3 = this.data.texto3;
    }
    else{
        this.timer = 25;
        this.titulo = "Atención"
        this.texto1 = `Parrafo1.`;
        this.texto2 = `Parrafo2.`;
        this.texto3 = `...`;
    }
  }
  
  onChange(): void {
    console.log("onChange");
  }

  ngOnDestroy(){
    clearInterval(this.inter);
    this.inter = null;    
  }

  fnCargaPopUp(){
    this.inter = setInterval(()=>{
      this.timer--;
      //console.log(this.timer);
      if (this.timer == 0){
        this.dialogRef.close('CERRADO');
      }
    },1000)
  }

}

